import React from 'react';
import { connect } from 'react-redux';

import EditField from '@components/common/editField';

import ColorWrapper from '@styles/colors';

import { getTools, create } from '@reducers/tools';

const AddTool = ({ C, tool, edit, setTool, showEdit, toogleEdit, isPopup = true, editConfig, getClampingTools, clampingTool }) => {
  return (
    <EditField
      key="EditField"
      {...{
        C,
        isPopup,
        showModal: showEdit,
        onClose: toogleEdit,
        header: editConfig.header,
        initData: editConfig.initData,
        rounded: true,
        onSubmit: async (d, onClose) => {
          const data = Object.assign({}, d);
          if (data.stickoutMM) {
            data.stickoutMM = Number(parseInt(data.stickoutMM));
          }

          await edit({
            toolId: tool.toolId,
            toolName: tool.toolName,
            description: tool.description,
            memo: tool.memo,
            stickoutMM: tool.stickoutMM,
            ...data,
          });
          if (getClampingTools) {
            await getClampingTools({ ncFileId: clampingTool.ncFileId });
          }
          setTool({
            ...tool,
            ...data,
          });

          onClose();
        },
        inputs: editConfig.inputs,
      }}
    />
  );
};

export default connect(({ tools: { tools, loaded } }) => ({ tools, loaded }), {
  getTools,
  create,
})(ColorWrapper(AddTool));
